import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          setting: {
            tabs: {
              manual_subaffiliate: {
                tab_name: 'TAB_NAME',
                affiliate_invitation_id: 'AFFILIATE_INVITATION_ID',
                date: 'DATE',
              },
            },
          },
        },
      },
    },
  }));
}
